import React, {useState} from 'react'
import UiKit from "../../../../../common/uikit"
import parse from "react-html-parser"

const Blog = () => {
    const [s, setState] = useState({
        data    : "",
        lan     : 0,
        title   : null,
        image   : null,
    })
    
    const languageOption = [
        {
            "text" : "türkçe",
            "value": 0
        },
        {
            "text" : "english",
            "value": 1
        },
    ]
    const languageOptions = () => {
        return languageOption.map(l => ({
            text    : l.text,
            value   : l.value
        }))
    }

    const changeFilterModel = (node, value) => {
        let state     = Object.assign({}, s);
        state[node]   = value;
        setState({
            ...s,
            ...state
        });
    }
    
    return (
        <div className="add-blog-container">
        <div>
        <form className="form-wrapper">
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8" sm="12" md="12">
                        <UiKit.Textfield
                            full
                            required
                            placeholder = "blog title"
                            value       = { s.title }
                            onChange    = { value => changeFilterModel('title', value) }
                            // errors      = { s.errors['website'] }
                            // isDisabled  = { redux.isLoading }
                        />
                    </UiKit.Col>
                </UiKit.Row>
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8"sm="12" md="12">
                        <div className="file-upload">
                            <input type="file" name="file"  placeholder="resim sec"/>
                        </div>
                    </UiKit.Col>
                    { /*
                        <UiKit.Col className="p8"sm="6" md="6">
                            <UiKit.Dropdown
                                full
                                required
                                placeholder  = "Dil Seçiniz"
                                options      = { languageOptions() }
                                onChange     = { ({ value }) => changeFilterModel('lan', value) }
                                value        = { s.lan }
                            />
                        </UiKit.Col>
                    */}
                </UiKit.Row>
            </form>
        </div>
            <div className="blog-text">
                <p>Blog detayi giriniz</p>
                <div className="editor">
                    <UiKit.Editor
                        data    = { s.data }
                        edit    = { (value) => changeFilterModel('data',value) }
                        plugIns = {[ 'key-binder' ]}
                    />
                </div>
            </div>
           <div className="show-wrapper">
                <h1>Son Haline Göz At 🧐</h1>
                <div className="show-blog">
                    {s.data && parse(s.data)}
                </div>
           </div>
           <div className="footer">
               <button>Yayınla</button>
           </div>
        </div>
    )
}

export default Blog
